// Установили текущую версию данных
import { copyObject } from '@/lib/objects'

import { SUB_EX_SUMMARY, SUB_VERSION_MIGRATION } from '@/store/const/expertise'

import { ASSESSMENT_ORGANIZATION } from './summaryScore/assessmentConst'
import {
  DEFAULT_RELEASE_FORM,
  EX_PRICE_CHARACTERISTICS,
} from './summaryPurchase/purchaseConst'
import { DEFAULT_GVS_FORM } from './summaryGVS/gvsConst'
import { DEFAULT_ADDITIONAL_INFO } from './summaryAdditional/addConst'
import { createSummaryKeiCopy } from './summaryAdditional/keiUtils'
import { createSummaryAvbCopy } from './summaryAdditional/avbUtils'
import {
  pickKeiReportSource,
  pickAvbReportSource,
} from './summaryAdditional/reportExpertiseSource'
import {
  DEFAULT_CR_PRESENCE,
  formatCrPresencePresentation,
  normalizeCrPresence,
} from '@/components/expSummary/summaryCrPresence/crPresenceConst'

// версия набора данных экспертизы
export const EX_SUMMARY_TEMPLATE_VERSION = 4

// ГЛАВНЫЙ ШАБЛОН ЭКСПЕРТИЗЫ
export const EX_SUMMARY_TEMPLATE = {
  mnn: '',
  gnvlp: false,
  vzn14: false,
  lForma: '',
  ruDate: '',
  /** Подавался ли ЛП ранее (представление). */
  previousProposalSubmitted: false,
  /** Текст при «да»; при «нет» — «Нет». */
  previousProposalText: 'Нет',
  ruHolder: '',
  manufacturer: '',
  /** Наличие МНН в перечне критической промышленной продукции. */
  inCriticalIndustrialProductList: false,
  isOrphan: false,
  /** @deprecated строка из аналогов; для Word — crPresence */
  crNames: '',
  crPresence: DEFAULT_CR_PRESENCE(),
  condition: '',
  // company: '',
  purchaseData: {
    year: '', //Год
    subjects: '', //Субъекты
    //Формы выпуска
    releaseForms: [DEFAULT_RELEASE_FORM()],
  }, //Данные по закупке
  priceCharacteristics: [EX_PRICE_CHARACTERISTICS()], //Ценовая характеристика ЛП
  assessmentOrganization: ASSESSMENT_ORGANIZATION(), //Оценка экспертной организаций
  gvs: [DEFAULT_GVS_FORM()], //оценка ГВС
  additionalInfo: DEFAULT_ADDITIONAL_INFO(), //Дополнительная информация.
}

/** Копируем данные initData - поверх oldData */
export function copySummaryExp(oldData, newData = {}) {
  const { about, other, analog } = newData

  const data = copyObject({
    ...EX_SUMMARY_TEMPLATE,
    ...(oldData || EX_SUMMARY_TEMPLATE),
  })

  data.mnn = about?.mnn || ''
  data.gnvlp = about?.gnvlp || false
  data.vzn14 = about?.vzn14 || false
  data.lForma = about?.lForma || ''
  data.ruDate = about?.ruDate || ''
  data.isOrphan = about?.isOrphan || false
  data.condition = about?.condition || ''
  if (!data.additionalInfo) data.additionalInfo = DEFAULT_ADDITIONAL_INFO()
  data.additionalInfo.kei = createSummaryKeiCopy(
    data.additionalInfo.kei,
    pickKeiReportSource(newData)
  )
  data.additionalInfo.avb = createSummaryAvbCopy(
    data.additionalInfo.avb,
    pickAvbReportSource(newData)
  )

  data.gvs.forEach(item => {
    const otherSum = other?.sum || 0
    item.scoreFGBU = otherSum
    if (Number(item.initOtherSum || 0) === 0) {
      item.initOtherSum = otherSum
    }
  })

  // Поля только представления — не перетираем при обновлении из других экспертиз
  if (oldData) {
    data.previousProposalSubmitted = oldData.previousProposalSubmitted ?? false
    data.previousProposalText = oldData.previousProposalText ?? 'Нет'
    data.ruHolder = oldData.ruHolder ?? ''
    data.manufacturer = oldData.manufacturer ?? ''
    data.inCriticalIndustrialProductList =
      oldData.inCriticalIndustrialProductList ?? false
    data.crPresence = normalizeCrPresence(
      oldData.crPresence,
      oldData.crNames
    )
  } else if (!data.crPresence) {
    data.crPresence = DEFAULT_CR_PRESENCE()
  }
  data.crNames = formatCrPresencePresentation(
    data.crPresence,
    oldData?.crNames
  )

  return data
}

// Установили текущую версию данных
SUB_VERSION_MIGRATION[SUB_EX_SUMMARY].v = EX_SUMMARY_TEMPLATE_VERSION

// Добавили миграции для перехода на версию 2
SUB_VERSION_MIGRATION[SUB_EX_SUMMARY][1] = function (prev) {
  if (prev) {
    const comment = prev.assessmentOrganization?.comment || ''
    prev.assessmentOrganization.comments = [comment]

    for (const item of prev.gvs) {
      const comment = item.comment || ''
      item.comments = [comment]
    }
  }
  return prev
}

SUB_VERSION_MIGRATION[SUB_EX_SUMMARY][2] = function (prev) {
  if (!prev) return copyObject(EX_SUMMARY_TEMPLATE)
  return {
    ...prev,
    previousProposalSubmitted: prev.previousProposalSubmitted ?? false,
    previousProposalText: prev.previousProposalText ?? 'Нет',
    ruHolder: prev.ruHolder ?? '',
    manufacturer: prev.manufacturer ?? '',
    inCriticalIndustrialProductList:
      prev.inCriticalIndustrialProductList ?? false,
  }
}

SUB_VERSION_MIGRATION[SUB_EX_SUMMARY][3] = function (prev) {
  if (!prev) return copyObject(EX_SUMMARY_TEMPLATE)
  const crPresence = normalizeCrPresence(prev.crPresence, prev.crNames)
  return {
    ...prev,
    crPresence,
    crNames: formatCrPresencePresentation(crPresence, prev.crNames),
  }
}
